module.exports = __webpack_public_path__ + "img/fnlogo.06f067bd.svg";